$('#articles').on('click', '#load-older-posts', function(e) {
  
// prevent new page load

  e.preventDefault();
  
// store next page number

  var next_page = $(this).attr('href');
  
// remove older posts button from DOM

  $(this).remove();
  
// ajax older posts below existing posts

  $('#articles').append(
    $('<div />').load(next_page + ' #articles')
  );
});